
export const CHECKOUT_URL =
  'https://pressed-flower-studio.impultienda.ar/checkout/pressed-flower-studio'

export const UPSELL_LINKS = {
  resina: '#botanical-resin-decor',
  bordado: '#botanical-floral-embroidery',
}

export const BRAND = {
  name: 'Pressed Flower Studio',
  product: 'Pressed Flower Studio',
  subtitle: 'The Complete Guide to Flower Pressing & Botanical Crafts',
  logo: 'https://cdn.magicpatterns.com/uploads/3htjHFW9hH2bn6exXMmU3L/LOGO_DECOEMPRENDE.png',
  ebookMockup:
    'https://cdn.magicpatterns.com/uploads/4M1a8xdUiCtTkQWyBqk2x4/PRESSED_FLOWERS_STUDIO_MOCKUP.png',
}

export const TRUST_POINTS = [
  '50+ pages · 9 pressing methods',
  'No experience needed',
  'Works with flowers from your own garden',
  '10 step-by-step projects',
]

export const COUNTDOWN = [
  { value: '00', label: 'Hours' },
  { value: '30', label: 'Min' },
  { value: '00', label: 'Sec' },
]

export const offerIncludes: string[] = [
  'The complete 50+ page digital guide, from first flower to finished piece',
  '9 flower pressing methods explained step by step',
  '10 botanical projects with materials and measurements',
  '4 bonus resources included, printable at home',
  'Instant download · lifetime access on any device',
]
